import { useEffect } from 'react';
import { BoxSelect } from '@wkda/funnel-components';
import { Field } from 'react-final-form';
import { useCarleadCreationFormStore } from '../../Form/CarleadCreationFormStore';
import shallow from 'zustand/shallow';
import { jsx as _jsx } from "react/jsx-runtime";
function FieldRenderer(_ref) {
  let {
    input,
    props
  } = _ref;
  const {
    type: _type,
    ...restInput
  } = input;
  const {
    onChange,
    mktSelector
  } = props;
  const [value, setLabel] = useCarleadCreationFormStore(state => [state.values[input.name], state.setLabel], shallow);
  useEffect(() => {
    if (typeof value !== 'undefined') {
      var _props$options$find;
      setLabel(input.name, (_props$options$find = props.options.find(o => o.value === value)) === null || _props$options$find === void 0 ? void 0 : _props$options$find.label);
    }
    return () => {
      setLabel(input.name, undefined);
    };
  }, [input.name, props.options, setLabel, value]);
  return /*#__PURE__*/_jsx(BoxSelect, {
    ...restInput,
    ...props,
    onChange: v => {
      restInput.onChange(v);
      onChange(v);
    },
    mktSelector: mktSelector === null || mktSelector === void 0 ? void 0 : mktSelector.value
  });
}
export function boxSelectRenderer(_ref2) {
  let {
    name,
    ...props
  } = _ref2;
  return /*#__PURE__*/_jsx(Field, {
    name: name,
    props: props,
    render: FieldRenderer
  });
}